import { Col, Modal, Row, Typography } from 'antd';
import moment from 'moment';
import type { FC } from 'react';
import React from 'react';

import Messages from './Messages';
import type { DetailProps } from './types';

const Detail: FC<DetailProps> = ({ feedback, user, open, onClose }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
      destroyOnClose
      title="查看意見內容"
    >
      {feedback && (
        <Row>
          <Col span={8}>
            <Typography.Title level={5}>標題</Typography.Title>
            <Typography.Text>{feedback.title}</Typography.Text>
            <Typography.Title level={5}>類別</Typography.Title>
            <Typography.Text>{feedback.type}</Typography.Text>
            <Typography.Title level={5}>建立時間</Typography.Title>
            <Typography.Text>
              {moment(feedback.createdTime).format('YYYY/MM/DD HH:mm')}
            </Typography.Text>
          </Col>
          <Col span={16}>
            <Messages feedbackId={feedback._id} user={user} />
          </Col>
        </Row>
      )}
    </Modal>
  );
};

export default Detail;
